const znJSON = {
  'Accent Sidebar': '口音側邊欄',
};

export default znJSON;
